import { useState } from 'react';

const faqs = [
  {
    question: '天堂影视的电视剧需要付费吗？',
    answer: '完全不需要！天堂影视所有电视剧资源全部免费在线观看，无需注册、无需付费、无任何隐藏消费。我们致力于为追剧爱好者提供完全免费的观影体验。',
  },
  {
    question: '为什么观看时不会缓冲和卡顿？',
    answer: '天堂影视采用全球CDN加速技术和先进的视频编码压缩方案，确保在不同网络环境下都能流畅播放。我们使用H.265高效编码，在保证高清画质的同时大幅降低带宽需求。',
  },
  {
    question: '剧集更新频率是怎样的？',
    answer: '热门剧集每日同步更新，与播出平台保持同步。更新时间为每日凌晨2:00至6:00，确保您起床后就能看到最新内容。完结剧集会标记"全X集"，方便您一口气追完。',
  },
  {
    question: '真的完全没有广告吗？',
    answer: '是的！天堂影视郑重承诺：所有剧集播放全程无任何广告干扰。无论是片头广告、插播广告还是弹窗广告，在这里全部不存在。我们相信纯粹的内容才是最好的体验。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！天堂影视完美适配手机、平板和电脑端，无需下载任何APP，打开浏览器即可观看。播放进度会自动同步，切换设备也能无缝继续追剧。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过页面底部的在线客服入口联系我们，客服团队7×24小时在线。也可以发送邮件至contact@tiantangyingshi.com，我们会在24小时内回复您的咨询。',
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              常见问题
            </h2>
            <p className="text-sm text-foreground-400 mt-2">关于天堂影视，你可能想了解的都在这里</p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer bg-background-100/50 hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg shrink-0 w-5 h-5 flex items-center justify-center ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}